<template>
  <section class="profile-change-password form-section">
    <header>Изменение пароля</header>
			<VForm ref="form">
				<VInput
					v-model="form.password"
					label="Новый пароль"
					layout="vertical"
					type="password"
					required
				/>

				<VInput
					v-model="form.repeat"
					label="Повторите"
					layout="vertical"
					type="password"
					required
				/>
			</VForm>

    <footer>
      <VButton
        theme="primary"
				:disabled="!form.password || !form.repeat"
        @click="save"
      >
        Сохранить
      </VButton>
    </footer>
  </section>
</template>

<script>

import ValidationFormMixin from "@/mixins/validation-form-mixin";

export default {
	name:   'ChangePassword',

	mixins: [ValidationFormMixin],

	data() {
		return {
			form: {
				password: null,
				repeat:   null,
			},
		};
	},

	methods: {
		async save() {
			await this.validate();

			if (!this.isValid) return;

			if (this.form.password !== this.form.repeat) {
				this.$core.showNotification.error('Пароли не совпадают');
				return;
			}

			if (this.form.password !== null && this.form.password.length > 0) {
				const success = await this.$core.acl.changePassword(this.form.password);

				if (success) {
					this.resetForm();
				}
			}
		},

		resetForm() {
			this.form = {
				password: null,
				repeat:   null,
			};

			/** поля стерли, валидацию обновляем, чтобы пустые значения не валидировались */

			this.$refs.form.reset();
		},

	},
};
</script>
